import React from 'react';
import './AboutOurClub.css';
import { aboutSections } from '../data/aboutOurClubSections';

interface AboutOurClubProps {
  onNavigate: (page: string) => void;
}

const AboutOurClub: React.FC<AboutOurClubProps> = ({ onNavigate }) => {
  const handleTrialClick = () => {
    onNavigate('thinking-of-joining');
    setTimeout(() => {
      const element = document.getElementById('trial-classes');
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }, 100);
  };
  return (
    <section className="about-our-club-section">
      <div className="container">
        <h1 className="page-title">About Our Club</h1>
        <p className="page-subtitle">
          Learn more about our unique approach to Taekwon-Do and what makes our club special
        </p>

        <div className="club-content">
          {aboutSections.map((section) => (
            <div key={section.id} className="content-section">
              <h2 id={section.id}>{section.title}</h2>
              {section.content}
            </div>
          ))}
        </div>

        <p className="page-footer">
          Contact us for more information.

          We are currently offering 2-week trials in all classes. See the <span className="text-link" onClick={handleTrialClick}>"Trial Classes"</span> page for more information.
        </p>
      </div>
    </section>
  );
};

export default AboutOurClub;
